let initState = {
  clickFormExpandBtn: false, //表单展开
  shieldIPBtn: false,
  IPCityList: ['成都市', '南京市', '上海市','成都', '南京', '上海'],
}

let cloneDeep = (data) => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data)) 
}
const state = cloneDeep(initState)
const mutations = {
  SET_CLICKFORMEXPANDBTN: (state, clickFormExpandBtn) => {
    state.clickFormExpandBtn = clickFormExpandBtn
  },
}
const actions = {
  setClickFormExpandBtn({ commit }) {
    commit(`SET_CLICKFORMEXPANDBTN`, true)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
